import { useContext } from 'react'
import { Context } from '@paypalcorp/worldready-react'
import { formatMessage } from '../utils/localization/format_worldready'

export type GetContentFunction = (id: string, params?: Object) => string

export const useLocalizedContent = () => {
  const worldReadyContext = useContext(Context)

  const getContent: GetContentFunction = (id: string, params?: Object) => {
    return formatMessage({
      contentId: id,
      worldReady: worldReadyContext,
      formatOptions: params,
    })
  }

  return {
    getContent,
  }
}
